import React from "react";
import { FormProvider, useForm } from "react-hook-form";

import { SurveyPreviewBaseQuestion } from "./SurveyPreviewBaseQuestion";
import { SurveyPreviewNavigationButtons } from "./SurveyPreviewNavigationButtons";
import { Question, QuestionOptionType } from "./types";
import { PaziaRatingStars } from "components/atoms/PaziaRatingStars/PaziaRatingStars";
import { PaziaTextarea } from "components/atoms/PaziaTextarea/PaziaTextarea";
import { PaziaSurveyPreviewSelectList } from "./SurveyPreviewSelectList";

interface QuestionFormProps {
  question: Question;
  isVisible: boolean;
  onNext: (
    questionId: number,
    value: string,
    rating: number,
    isLast: boolean
  ) => void;
  onBack?: () => void;
}
export const QuestionForm = ({
  question,
  onBack,
  onNext,
  isVisible,
}: QuestionFormProps) => {
  const [errorMessage, setErrorMessage] = React.useState<string>("");
  const methods = useForm();
  const { handleSubmit } = methods;

  const onSubmit = (data: any) => {
    if (question.required && !data.answer && question.inputType !== "rating") {
      setErrorMessage("Odpowiedź na to pytanie jest wymagana.");
      return;
    }
    if (question.required && !data.rating && question.inputType === "rating") {
      setErrorMessage("Ocena jest wymagana.");
      return;
    }
    setErrorMessage("");
    const value = Array.isArray(data.answer)
      ? data.answer.join(",")
      : data.answer;
    if (question.id) onNext(question.id, value, data.rating, false);
  };

  return (
    <FormProvider {...methods}>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className={isVisible ? "" : "hidden"}
      >
        <SurveyPreviewBaseQuestion
          question={question.question}
          description={question.description}
        />

        {ratingFields.includes(question.inputType) && (
          <PaziaRatingStars
            name="rating"
            lowerLabel={question.lowerLabel ?? ""}
            upperLabel={question.upperLabel ?? ""}
          />
        )}
        {textFields.includes(question.inputType) && (
          <PaziaTextarea
            name="answer"
            rows={3}
            required={question.required}
            placeholder={question.placeholder}
          />
        )}
        {selectFields.includes(question.inputType) && (
          <PaziaSurveyPreviewSelectList
            name="answer"
            question={question}
            isMulti={question.inputType === "multi-select"}
          />
        )}
        {errorMessage && (
          <div className="text-red-500 text-sm mt-2">{errorMessage}</div>
        )}
        <SurveyPreviewNavigationButtons onBack={onBack} />
      </form>
    </FormProvider>
  );
};

const textFields: QuestionOptionType[] = [
  "free-text",
  "course-rating",
  "trainer-rating",
];
const ratingFields: QuestionOptionType[] = [
  "rating",
  "course-rating",
  "trainer-rating",
];
const selectFields: QuestionOptionType[] = ["single-select", "multi-select"];
